export default __webpack_public_path__ + "static/media/current-indicator.e4d51118.svg";